import apiFetch from '../apiFetch'

export default function (idProducto, idLote, token) {
  return apiFetch({endPoint: `Combos/getLotesProductoEspecificoActivo?idProducto=` + idProducto + '&idLote=' + idLote, method: 'GET', body: null, token: token})
}
